export default "__VITE_ASSET__674a9dcd__"